import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import Contact from './pages/Contact';
import PrivacyPolicy1 from './pages/PrivacyPolicy1.js';
import './App.css';

function App() {
  return (
    <>
      {/* Ambient background */}
      <div className="background-animated">
        <div className="bg-orb-mid" />
        <div className="grain" />
      </div>

      {/* App shell */}
      <div className="app-container">
        <Navbar />
        <Routes>
          <Route path="/"               element={<Home />} />
          <Route path="/contact"        element={<Contact />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy1 />} />
        </Routes>

        {/* Footer */}
        <footer style={footerStyles.footer}>
          <div style={footerStyles.inner}>
            <span style={footerStyles.brand}>Apps<span style={footerStyles.accent}>ViT</span> Limited</span>
            <span style={footerStyles.copy}>© {new Date().getFullYear()} All rights reserved.</span>
            <nav style={footerStyles.links}>
              <a href="/privacy-policy" style={footerStyles.link}>Privacy</a>
              <a href="/contact" style={footerStyles.link}>Contact</a>
            </nav>
          </div>
        </footer>
      </div>
    </>
  );
}

const footerStyles = {
  footer: {
    borderTop: '1px solid rgba(255,255,255,0.06)',
    padding: '24px 40px',
    marginTop: 'auto',
  },
  inner: {
    maxWidth: '1160px',
    margin: '0 auto',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '12px',
  },
  brand: {
    fontFamily: "'DM Sans', sans-serif",
    fontSize: '14px',
    fontWeight: 600,
    color: '#8b9bb4',
  },
  accent: { color: '#2dd4bf' },
  copy: {
    fontSize: '13px',
    color: '#4a5568',
  },
  links: {
    display: 'flex',
    gap: '20px',
  },
  link: {
    fontSize: '13px',
    color: '#4a5568',
    textDecoration: 'none',
    transition: 'color 0.2s',
  },
};

export default App;